import React from 'react'
import styled from 'styled-components'
import { StickyElem } from '../../StickyElem'

const getCssDisplay = ({ minScreenSize, theme }) =>
  minScreenSize && theme.flyQueries[minScreenSize]
    ? `
      display: none;
      ${theme.flyQueries[minScreenSize]} {
        display: block;
      }
    `
    : 'display: block;'

const StyledAd = styled.div`
  margin-bottom: ${(props) => props.marginBottom}px;
  margin-left: auto;
  margin-right: auto;
  ${(props) => props.fitWidth && 'width: fit-content;'}
  ${(props) => getCssDisplay(props)}
`

const StyledStickyContainer = styled(StickyElem)`
  ${(props) => getCssDisplay(props)}
`

const StandardAd = ({ minScreenSize, isSticky, className, adId, marginBottom, fitWidth }) => {
  return (
    <StyledStickyContainer
      minScreenSize={minScreenSize}
      disableStickiness={!isSticky}
      // override for package listing ad
      stickyThresholdTop={adId === 'div-gpt-ad-1528733208433-0' ? 84 : undefined}
    >
      <StyledAd
        className={className}
        id={adId}
        minScreenSize={minScreenSize}
        marginBottom={marginBottom}
        fitWidth={fitWidth}
      />
    </StyledStickyContainer>
  )
}

export { StandardAd }
